module.exports = __webpack_public_path__ + "img/kash_unit.gm.3909fe6.png";